import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Apollo } from 'apollo-angular';
import { PAYMENT_BILL_STATUSES } from '../../../../common/interfaces/global-interfaces';
import { NotificationService } from '../../../../services/notification.service';
import { SettingsService } from '../../../../services/settings.service';
import { SubscriptionAddComponent } from '../../../subscription-management/subscription-add/subscription-add.component';
import { GET_ALL_SUBSCRIPTION } from '../../../subscription-management/subscription.graphql';
import { Location } from "@angular/common";
@Component({
  selector: 'app-corporate-subscription-view',
  templateUrl: './corporate-subscription-view.component.html',
  styleUrl: './corporate-subscription-view.component.scss'
})
export class CorporateSubscriptionViewComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private apollo = inject(Apollo);
  private notify = inject(NotificationService);
  location = inject(Location);
  private settings = inject(SettingsService);

  


  subscription: any = null;
  loading = true;
  title = "Subscription Details";

  ngOnInit(): void {
    const uuid = this.route.snapshot.paramMap.get("uuid")!;

    if (!uuid) {
      this.notify.errorMessage("Invalid URL");
      this.loading = false;
      return;
    }
    this.loading = true;
    this.apollo
      .watchQuery<any>({
        query: GET_ALL_SUBSCRIPTION,
        variables: {
          filtering: { uuid, pageNumber: 0 },
        },
        fetchPolicy: "network-only",
        errorPolicy: "all",
      })
      .valueChanges.subscribe({
        next: (result) => {
          const items = result.data?.getAllSubscriptions?.data || [];

          if (items.length > 0) {
            this.subscription = items[0];
          } else {
            this.notify.errorMessage("Subscription not found");
          }
          this.loading = false;
        },
        error: (err) => {
          console.error("GraphQL Error:", err);
          this.notify.errorMessage("Failed to load subscription");
          this.loading = false;
        },
      });
  }

onReuseControlNumber(subscriptionUuid: string, controlNumber?: string): void {
  if (!subscriptionUuid) return;

  console.log('subscriptionUuid:', subscriptionUuid);
  console.log('controlNumber:', controlNumber); 
  this.settings.openDialogModal({
    component: SubscriptionAddComponent,
    data: {
      subscription: { uuid: subscriptionUuid },
      controlNumber: controlNumber || null,
    },
    width: '700px',
  });
}

  findStatusClass(statusValue) {
    return PAYMENT_BILL_STATUSES.find((status) => status.key == statusValue)
      .classes;
  }
  onViewBill(billUuid: string): void {
  this.router.navigate(['/manage/billing-management/bill-list', billUuid]);
}
}
